<div class="lw">
  <div class="lap">
    <div
      class="scr"
      role="region"
      aria-roledescription="carousel"
      [attr.aria-label]="titleText"
      tabindex="0"
      (keydown)="onKeydown($event)"
      (mouseenter)="pause()"
      (mouseleave)="resume()"
      (focusin)="pause()"
      (focusout)="resume()"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
    >
      <div class="slides" [style.transform]="'translateX(' + (-index * 100) + '%)'" (click)="onSlideClick($event)">
        <figure
          class="slide"
          *ngFor="let s of slides; let i = index"
          role="group"
          aria-roledescription="slide"
          [attr.aria-label]="slideOfText + ' ' + (i + 1) + ' / ' + slides.length"
          [attr.aria-hidden]="i !== index"
        >
          <img [src]="s.src" [alt]="s.caption" draggable="false" decoding="async" />
        </figure>
      </div>

      <div class="cnt" aria-hidden="true">{{ pad(index + 1) }} / {{ pad(slides.length) }}</div>

      <button type="button" class="arr arr--prev" (click)="prev()" [attr.aria-label]="prevText">‹</button>
      <button type="button" class="arr arr--next" (click)="next()" [attr.aria-label]="nextText">›</button>

      <!-- Точки по бокам, в середине — название текущего слайда (активная точка превращается в подпись) -->
      <div class="dots" role="tablist" [attr.aria-label]="tabsLabelText">
        <ng-container *ngFor="let s of slides; let i = index">
          <span class="dots__label" *ngIf="i === index" role="tab" aria-selected="true">{{ s.label }}</span>
          <button
            *ngIf="i !== index"
            type="button"
            role="tab"
            class="dot"
            aria-selected="false"
            [attr.aria-label]="s.label"
            [attr.title]="s.label"
            (click)="goTo(i)"
          ></button>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="base" aria-hidden="true"></div>
</div>

<!-- Полноэкранный горизонтальный просмотр (мобильная версия) -->
<div
  class="fs"
  *ngIf="fullscreen"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="titleText"
  tabindex="-1"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown)="onFsKeydown($event)"
  (touchstart)="onFsTouchStart($event)"
  (touchend)="onFsTouchEnd($event)"
>
  <div class="fs-stage">
    <img
      class="fs-img"
      [src]="slides[index].src"
      [alt]="slides[index].caption"
      draggable="false"
      (click)="next()"
    />
    <div class="cnt" aria-hidden="true">{{ pad(index + 1) }} / {{ pad(slides.length) }}</div>
    <button type="button" class="fs-close" (click)="closeFullscreen()" [attr.aria-label]="closeText">✕</button>
    <button type="button" class="arr arr--prev" (click)="prev()" [attr.aria-label]="prevText">‹</button>
    <button type="button" class="arr arr--next" (click)="next()" [attr.aria-label]="nextText">›</button>

    <!-- Те же точки с названием слайда, что и на экране ноутбука -->
    <div class="dots" role="tablist" [attr.aria-label]="tabsLabelText">
      <ng-container *ngFor="let s of slides; let i = index">
        <span class="dots__label" *ngIf="i === index" role="tab" aria-selected="true">{{ s.label }}</span>
        <button
          *ngIf="i !== index"
          type="button"
          role="tab"
          class="dot"
          aria-selected="false"
          [attr.aria-label]="s.label"
          (click)="goTo(i)"
        ></button>
      </ng-container>
    </div>
  </div>
</div>
